// Shared with global search so folder links match ReportsView's routes.
export function slugifyFolder(folder: string): string {
  return folder?.toLowerCase().replace(/\s+/g, "-");
}
